import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  Button,
//   Paper,
  Stack,
//   useMediaQuery,
//   useTheme,
  Alert,
//   Chip,
} from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import ProfileDetails from '../profile/ProfileDetails';
import AccountDeactivation from './forms/AccountDeactivation';
import LoadingComponent from '../utils/LoadingComponent';
import { AuthContext } from './AuthContext';
import { showSwalNotification } from '../utils/SwalResponse';
import Swal from 'sweetalert2';
// Dummy data


const UserManagement = () => {

  const { getUserByQuery, updateUserStatus,currentUser } = useContext(AuthContext)
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const [query, setQuery] = useState('');
  const [foundUser, setFoundUser] = useState(null);
  const [deactivate, setDeactivate] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    setLoading(true);
    const user = await getUserByQuery(query);
    showSwalNotification(user);
    if (user) {
      setFoundUser(user?.data);
      setError('');
    } else {
      setFoundUser(null);
      setError('User not found');
    }
    setLoading(false);
  };
  

  async function activateAccount() {
  const result = await Swal.fire({
    title: 'Activate Account?',
    text: 'Do you really want to activate this account?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#1976d2', // MUI primary
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, Activate',
    cancelButtonText: 'Cancel',
    reverseButtons: true,
  });

  if (result.isConfirmed) {
    try {
        setLoading(true);
      const response = await updateUserStatus({reason:'',user_id: foundUser.id, status: 'active'});
      showSwalNotification(response);
      if (response?.status === 'success') {
        setFoundUser(response?.data);
      }
    } catch (err) {
      console.error(err);
      showSwalNotification({ status: 'error', message: 'Something went wrong during activation.' });
    } finally {
      setLoading(false);
    }
  }
}

useEffect(() => {
  if (!currentUser || currentUser?.role !== 'support') {
    navigate(-1);
  }
}, [currentUser])


  if (!!loading) return <LoadingComponent loadingText={"Loading User ..."}/>;

  return (
    <Box sx={{ px: 3, py: 6, background: '#f5fdf7', minHeight: '100vh' }}>
      <Stack direction="row" justifyContent="center" alignItems="center" mb={4}>
        <Typography variant="h4" fontWeight="bold" color="#2e7d32">
          User Management
        </Typography>
        <Button
          variant="outlined"
          onClick={() => navigate(-1)}
          sx={{ borderColor: '#2e7d32', color: '#2e7d32' ,m:5}}
        >
          Back
        </Button>
      </Stack>

      <Box
        component={motion.div}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Stack spacing={2} alignItems="center" mb={4}>
          <TextField
            label="Search by Email, ID or Phone"
            type="search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            fullWidth
            sx={{ maxWidth: 500 }}
          />
          <Button
            variant="contained"
            onClick={handleSearch}
            sx={{
              backgroundColor: '#2e7d32',
              '&:hover': { backgroundColor: '#1b5e20' },
              fontWeight: 'bold',
            }}
          >
            Search
          </Button>
        </Stack>

        {error && (
          <Alert severity="error" sx={{ maxWidth: 500, mx: 'auto', mb: 3 }}>
            {error}
          </Alert>
        )}

        {foundUser && (

            <Stack direction="row" justifyContent="center" alignItems="center" mb={4}>
                <ProfileDetails user={foundUser} />
            </Stack>
        )}
        
        <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} >
        {(!!foundUser) && (
            foundUser.status === 'active' ? (
            <Button
                onClick={() => setDeactivate(true)}
                variant="contained"
                color={'error'}
              >
                Deactivate
              </Button>
              ):(
                <Button
                onClick={activateAccount}
                variant="contained"
                color={'success'}
              >
                Activate
              </Button>
              )
        )}
        </Stack>
        <AccountDeactivation setLoading={setLoading} open={deactivate} user={foundUser} setFoundUser={setFoundUser} onClose={() => setDeactivate(false)} />

      </Box>
    </Box>
  );
};

export default UserManagement;
